import { BaseService } from '../../../../../core/services/base.service';
import {
  RecruiterNotification,
  RecruiterNotificationFeed,
} from '../models/recruiter-notification.model';

const propagate = (error: Error) => {
  throw error;
};

export class RecruiterNotificationService {
  static feed(size = 12): Promise<RecruiterNotificationFeed> {
    return BaseService.Get(
      `/recruiter-notifications?size=${size}`,
      propagate,
      false
    );
  }

  static markRead(id: string): Promise<RecruiterNotification> {
    return BaseService.Post(
      `/recruiter-notifications/${id}/read`,
      {},
      propagate,
      false
    );
  }

  static markAllRead(): Promise<void> {
    return BaseService.Post(
      '/recruiter-notifications/read-all',
      {},
      propagate,
      false
    );
  }
}
